<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="primary">close</mat-icon>
</button>
<h2 mat-dialog-title>Terms and Conditions</h2>
<mat-dialog-content class="mat-typography">
  <div class="">
    <h3 class="">Effective Date: [01-November-2023] </h3>
    <h4 class="">1. Acceptance of Terms </h4>
    <p class="">By using the Refresh Contractor Portal website ("https://dev.contractor.controlfms.com"), you agree to
      be bound by these Terms and Conditions. If you do not agree with these Terms and Conditions, please do not use the
      Website.
    </p>
  </div>
  <div class="">
    <h4 class="">2. Use of the Website </h4>
    <p class="">

      2.1. Eligibility: You must be at least 18 years old to use this Website.

    </p>
    <p class="">
      2.2. User Accounts: To access certain features of the Website, you may be required to register for an account. You
      agree to provide accurate, current, and complete information during the registration process and to update such
      information to keep it accurate, current, and complete.
    </p>
    <p class="">
      2.3. Security: You are responsible for maintaining the confidentiality of your account and password and for
      restricting access to your account. You accept responsibility for all activities that occur under your account.
    </p>
  </div>
  <div class="">
    <h4 class="">3. Privacy
    </h4>
    <p class="">Your use of the Website is also governed by our Privacy Policy, which is incorporated by reference into
      these Terms and Conditions. Please review our Privacy Policy for information on how we collect, use, and disclose
      personal information.
    </p>
  </div>
  <div class="">
    <h4 class="">4. Intellectual Property </h4>
    <p class="">All content on the Website, including but not limited to text, graphics, logos, images, and software, is
      the property of Refresh Renovations and is protected by copyright and other intellectual property laws. You may
      not use, reproduce, distribute, or create derivative works based on this content without express written consent
      from Refresh Renovations.
    </p>
  </div>
  <div class="">
    <h4 class="">5. User Content </h4>
    <p class="">5.1. By submitting, posting, or displaying content on the Website (e.g., comments, reviews, messages),
      you grant Refresh Renovations a non-exclusive, worldwide, royalty-free, irrevocable, sublicensable license to use,
      reproduce, adapt, publish, translate, distribute, and display that content.
    </p>
    <p class="">5.2. You agree not to post or transmit content that is: </p>
    <p class="">
      a. Unlawful, harmful, threatening, abusive, defamatory, vulgar, obscene, or invasive of another's privacy.

    </p>
    <p class="">b. Infringing on any patent, trademark, trade secret, copyright, or other proprietary rights.

    </p>
    <p class="">c. Unauthorized advertising or solicitation.
    </p>
  </div>
  <div class="">
    <h4 class="">
      6. Termination
    </h4>
    <p class="">Refresh Renovations reserves the right to terminate or suspend your account and access to the Website at
      any time, with or without cause and with or without notice.
    </p>
  </div>
  <div class="">
    <h4 class="">
      7. Disclaimer of Warranties
    </h4>
    <p class="">
      The website is provided "as is" without warranties of any kind, whether express or implied. Refresh Renovations
      makes no representations or warranties about the accuracy or completeness of the content on the website.
    </p>
  </div>
  <div class="">
    <h4 class="">
      8. Limitation of Liability
    </h4>
    <p class="">
      Refresh Renovations shall not be liable for any indirect, incidental, special, consequential, or punitive damages,
      or any loss of profits or revenues, whether incurred directly or indirectly.
    </p>
  </div>
  <div class="">
    <h4 class="">9. Changes to Terms and Conditions
    </h4>
    <p class="">
      Refresh Renovations reserves the right to modify these Terms and Conditions at any time. It is your responsibility
      to review these Terms and Conditions periodically for changes.
    </p>
  </div>
  <div class="">
    <h4 class="">10. Governing Law
    </h4>
    <p class="">These Terms and Conditions are governed by and construed in accordance with the laws of your country of
      residence.
    </p>
  </div>
  <div class="">
    <h4 class="">11. Contact Information
    </h4>
    <p class="">

      For questions or concerns about these Terms and Conditions, please use the contact form at www.refresh.co.nz

    </p>
    <p class="">
      By using the Website, you acknowledge that you have read, understood, and agree to be bound by these Terms and
      Conditions.
    </p>
  </div>



</mat-dialog-content>
<!-- <mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions> -->